import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HelpRequestIcon from '../../../assets/img/planner-help-icon.svg';
import HomeIcon from '@material-ui/icons/Home';
import PrintIcon from '@material-ui/icons/Print';
import HelpIcon from '@material-ui/icons/Help';
import HelpApplication from '../../HelpApplications/HelpApplication';
import { useReactToPrint } from 'react-to-print';
import { isStudent, isAlumni } from '../../../util/miscUtil';

const HelpApp = ({
  senior,
  alumni,
  roles,
  handleHelp,
  store,
  auth,
  handleAfterSaveReturn,
  setPage,
  handleReturnToSeniorList,
  classes,
  handleGotoAdminHomepage,
}) => {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <React.Fragment>
      {!isStudent(roles) && !isAlumni(roles) && (
        <div className={classes.breadcrumb}>
          <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
            <span className={classes.breadCrumbLink} onClick={(e) => handleGotoAdminHomepage()}>
              <HomeIcon style={{ fontSize: '1.30rem' }} />
              <span style={{ margin: '1px 0 0 1px' }}>Home</span>
            </span>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
              Alumni List
            </span>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
              {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
              {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
            </span>
            <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('helpapps')}>
              Help Requests
            </span>
            <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
              Request
            </span>
          </Breadcrumbs>
        </div>
      )}
      <Grid container spacing={2} direction="row" className={classes.menu} ref={componentRef}>
        <Grid item xs={12} align="left" className={classes.unprintedContent}>
          <Card className={classes.pageHeader}>
            <CardBody className={classes.headerCard}>
              <Grid container direction="row">
                <Grid item xs={12} sm={7} md={6} align="left">
                  <section className={classes.pageTitle}>
                    <img src={HelpRequestIcon} alt="Help Request Icon" className={classes.pageIcon} />
                    <span className={classes.pagecardHeader}>Help Request</span>
                  </section>
                  <aside className={classes.headerDesc}>Please enter the information below to request help from Boys Town.</aside>
                </Grid>
                <Grid item xs={12} sm={5} md={6} align="right">
                  <Tooltip title="Click to return to the planner home page." placement="bottom">
                    <IconButton color="inherit" aria-label="return home" onClick={(e) => setPage('home')}>
                      <HomeIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to open the printer dialog." placement="bottom">
                    <IconButton color="inherit" aria-label="print scholarship application" onClick={handlePrint}>
                      <PrintIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Click to return to view printer tips & tricks." placement="bottom">
                    <IconButton color="inherit" aria-label="printer tips and tricks" onClick={handleHelp}>
                      <HelpIcon className={classes.homeIcon} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} align="left" className={classes.printedContent}>
          <section className={classes.pageTitle}>
            <span className={classes.printHeaderText}>Help Request</span>
          </section>
          <aside className={classes.printHeaderDesc}>Please enter the information below to request help from Boys Town.</aside>
        </Grid>
        <Grid item xs={12}>
          <HelpApplication SeniorStore={store} AuthStore={auth} handleSaveReturn={handleAfterSaveReturn} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

HelpApp.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  handleHelp: PropTypes.func,
  store: PropTypes.object,
  auth: PropTypes.object,
  handleAfterSaveReturn: PropTypes.func,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default HelpApp;
